
const CaarlTourOverlay = ({ onClick }: { onClick: () => void }) => {
  return (
    <div className="fixed inset-0 bg-black/80 z-[999]" onClick={onClick} />
  )
}

export default CaarlTourOverlay